import React from "react";
import successIcon from "../../../assets/icons/flash-message/success.png";
import "./SuccessMessage.css";

const SuccessMessage = ({ message, onClose }) => {
  if (!message) return null;
  return (
    <div className="success-message-card">
      <div className="success-message-icon">
        <img src={successIcon} alt="Success" />
      </div>
      <span className="success-message-text">{message}</span>
      <button
        className="success-message-close"
        onClick={onClose}
        aria-label="Close success"
        type="button"
      >
        ×
      </button>
    </div>
  );
};

export default SuccessMessage;
